import StarRatingInput from "./StarRatingInput.component";

export default StarRatingInput;
